import { InstallationType, InstallationTypeValue } from "$src/domain/projects/installations/InstallationType";
import { useQuery } from "@sveltestack/svelte-query";

const installationTypes: InstallationTypeValue[] = 
[
    {
        id: InstallationType.None,
        translations: []
    },
    {
        id: InstallationType.CompleteInstallation,
        translations: []
    },
    {
        id: InstallationType.InstallationAssistance,
        translations: []
    }
]

export async function fetchTypes(groupStoreId: number): Promise<InstallationTypeValue[]> {
   
    return Promise.resolve(installationTypes);
}

export function useInstallationType(groupStoreId: number) {

    return useQuery<InstallationTypeValue[], Error>({
        queryKey: ['installation-types', groupStoreId],
        queryFn: () => fetchTypes(groupStoreId),
        staleTime: 300000,
        cacheTime: 600000,
    });
}
